<template>
  <div class="yongsin-bar-chart">
    <VueApexCharts
      :height="isMobile ? '240' : '300'"
      :width="isMobile ? '360' : '500'"
      type="bar"
      :options="chartOptions"
      :series="series"
    />
    <div class="element-summary">
      <div v-for="(item, key) in fiveDistribution" :key="key" class="summary-item">
        <div class="bar-icon" :class="`color-${key}`"></div>
        {{ key }} : {{ item.모델수 }}개 모델 ({{ item.모델비율 }}%)
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const props = defineProps({
  yongsinProbability: {
    type: Object,
    required: true,
  },
  fiveDistribution: {
    type: Object,
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
})

const labels = computed(() => Object.keys(props.yongsinProbability))

const series = computed(() => [
  {
    name: '확률',
    data: labels.value.map((label) => props.yongsinProbability[label]?.확률 || 0),
  },
])

const fiveColorMap = {
  목: '#5E9F1C',
  화: '#C23535',
  토: '#DB9823',
  금: '#949494',
  수: '#404040',
}

// 옵션 구성
const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    toolbar: { show: false },
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      distributed: true,
      columnWidth: '55%',
      borderRadius: 8,
      borderRadiusApplication: 'end',
      dataLabels: {
        position: 'top',
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: (val) => `${val.toFixed(2)}%`,
    style: {
      fontWeight: 600,
      colors: ['#000'],
    },
    offsetY: -17,
    position: 'top',
  },
  tooltip: {
    y: {
      formatter: (val) => `${val.toFixed(2)}%`,
    },
  },
  xaxis: {
    categories: labels.value,
    labels: {
      style: {
        fontWeight: 600,
      },
    },
  },
  yaxis: {
    labels: {
      formatter: (val) => `${val.toFixed(0)}%`,
    },
    max: 100,
  },
  colors: labels.value.map((label) => {
    const element = props.yongsinProbability[label]?.용신오행
    return fiveColorMap[element] || '#cccccc'
  }),
}))
</script>

<style scoped lang="scss">
.yongsin-bar-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.element-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--Gray-800, #333);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  .bar-icon {
    width: 22px;
    height: 12px;
    border-radius: 8px 8px 0 0;
  }
}

.color-목 {
  background-color: #5e9f1c;
}
.color-화 {
  background-color: #c23535;
}
.color-토 {
  background-color: #db9823;
}
.color-금 {
  background-color: #949494;
}
.color-수 {
  background-color: #404040;
}
</style>
